import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { ClientsWoESolutionDetailService, ClientsWoESolutionDetailServiceData } from "../../services/administrativeManagementDigitalizationKpi/clientsWoESolutionDetail.service";
import { TextColumnDefinition, ColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { SingleSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";

export class ClientsWoESolutionExtendedData {
    public office: number;
    public s1: number;
    public s2: number;
    public s3: number;
    public s4: number;

    constructor(office: number, s1: number, s2: number, s3: number, s4: number) {
        this.office = office;
        this.s1 = s1;
        this.s2 = s2;
        this.s3 = s3;
        this.s4 = s4;
    }
}

export class ClientsWoESolutionExtendedDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}

@Component({
    selector: 'client-wo-esolution-extended-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class ClientsWoESolutionExtendedKpiServiceHostComponent extends SingleSummaryDetailKpiServiceHost<ClientsWoESolutionDetailService, ClientsWoESolutionDetailServiceData, ClientsWoESolutionExtendedData, ClientsWoESolutionExtendedDetailData>
    implements OnDestroy {
    public getClassName() { return "ClientsWoESolutionExtendedKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService,
        private officeSelectorService: OfficeSelectorService, summaryDetailService: ClientsWoESolutionDetailService) {
        super(zone, logger, summaryDetailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: ClientsWoESolutionDetailServiceData): ClientsWoESolutionExtendedData {
        return new ClientsWoESolutionExtendedData(
            data.clients.length,
            (data.clients.filter(x => x.centerSegment == "1") || []).length,
            (data.clients.filter(x => x.centerSegment == "2") || []).length,
            (data.clients.filter(x => x.centerSegment == "3") || []).length,
            (data.clients.filter(x => x.centerSegment == "4") || []).length,
        );
    }
    protected getDefaultSummaryData(): ClientsWoESolutionExtendedData {
        return new ClientsWoESolutionExtendedData(0,0,0,0,0);
    }


    protected extractUpdateTime(data: ClientsWoESolutionDetailServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: ClientsWoESolutionDetailServiceData): ClientsWoESolutionExtendedDetailData {
        
        if (data.clients) {
            let columnDefinitions = [
                new TextColumnDefinition("Cliente"),
                new TextColumnDefinition("Centro"),
                new TextColumnDefinition("Segmento"),
                new TextColumnDefinition("Términos y Condiciones", (data) => data ? "" : "Sin aceptar")
            ];
            
            let tabledata = [];

            data.clients = data.clients.sort(function (a, b) {
                if (a.centerSegment > b.centerSegment) {
                    return 1;
                }
                if (a.centerSegment < b.centerSegment) {
                    return -1;
                }
                return 0;
            });

            for (let client of data.clients) {
                tabledata.push([
                    client.clientFiscalName,
                    client.centerCode,
                    client.centerSegment,
                    client.ToSAccepted
                ]);
            }
            return new ClientsWoESolutionExtendedDetailData(columnDefinitions, tabledata);
        }
        else return this.getDefaultDetailData();
    }

    protected getDefaultDetailData(): ClientsWoESolutionExtendedDetailData {
        let columnDefinitions = [
            new TextColumnDefinition("Cliente"),
            new TextColumnDefinition("Centro"),
            new TextColumnDefinition("Segmento"),
            new TextColumnDefinition("Términos y Condiciones", (data) => data ? "" : "Sin aceptar")
        ];

        return new ClientsWoESolutionExtendedDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }
}